import React from 'react'
import PropTypes from 'prop-types'
import { ParticipantTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const GestionParticipants = ({
  fetchData,
  isLoadingParticipantsList,
  participants,
  participantsCount,
  errorMessage,
  removeError,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  searchData,
  onCloseReset,
  fetchFiles,
  isErrorFetchFileById,
  errorMessageConfig,
  removeErrorConfig,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={false}
      tableHead={ParticipantTableHead}
      //Commonfields
      globalID={'Participant'}
      searchPlaceholder={'Rechercher par participant'}
      title={'Gestion participants'}
      fetchData={fetchData}
      loadingData={isLoadingParticipantsList}
      dataList={participants}
      countData={participantsCount}
      errorMessage={errorMessage || errorMessageConfig}
      removeError={removeError}
      removeErrorConfig={removeErrorConfig}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      fetchFiles={fetchFiles}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isParticipant={true}
      isErrorFetchFileById={isErrorFetchFileById}
    />
  )
}
GestionParticipants.propTypes = {
  fetchData: PropTypes.func,
  isLoadingParticipantsList: PropTypes.bool,
  participants: PropTypes.array,
  participantsCount: PropTypes.number,

  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,

  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,

  success: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,

  searchData: PropTypes.func,
  onCloseReset: PropTypes.func,
  fetchFiles: PropTypes.func,
  isErrorFetchFileById: PropTypes.bool,

  errorMessageConfig: PropTypes.string,
  removeErrorConfig: PropTypes.func,
}
export default GestionParticipants
